import { useEffect, useState } from "react";

import ChooseBox from "../Choose/ChooseBox";
import MofaQR from "../Mofa/MofaQR";
import Upload from "../Upload/Upload";

import Ibcc from "../Ibcc/Ibcc";
import MultipleQR from "../MultipleQR/MultipleQR";
import AllIbcc from "../AllIbcc/AllIbcc";
import AllMofa from "../AllMofa/AllMofa";
import "./admin.css";

export default function AdminPanel({ setAuth }) {
  const [chooseBox, setChooseBox] = useState("");
  const [qrData, setQrData] = useState({}); // { path: "", text: { refCode: "", degree: "" } }

  const logout = () => {
    localStorage.clear();
    setAuth(false);
  };
  useEffect(() => {
    const handleQR = (event) => {
      setQrData(event.detail);
    };
    document.addEventListener("showQR", handleQR);
    return () => document.removeEventListener("showQR", handleQR);
  }, []);


  return (
    <div className="admin-panel-main">
      <div className="logout-main">
        <button onClick={logout}>Logout</button>
      </div>
      {!chooseBox && <ChooseBox setChooseBox={setChooseBox} />}
      {chooseBox == "mofa" && <MofaQR setChooseBox={setChooseBox} />}
      {chooseBox == "upload" && <Upload setChooseBox={setChooseBox} />}
      {chooseBox == "multiple" && <MultipleQR setChooseBox={setChooseBox} />}
      {chooseBox == "ibcc" && <Ibcc setChooseBox={setChooseBox} qrData={qrData}/>}
      {chooseBox == "all-ibcc" && <AllIbcc setChooseBox={setChooseBox} />}
      {chooseBox == "all-mofa" && <AllMofa setChooseBox={setChooseBox} />}
    </div>
  );
}
